import React, { useEffect, useRef, useState } from 'react';
import * as S from './styles';
import ArrowDown from '../../assets/icons/icon-arrow-down.svg';
import { BodyMSpan, TaglinePSpan } from '../../styles/stylesTypography';
import { isTotvs } from '../../services/globalFunctions';

const GOOGLE_EMAIL = '@agroreceita_google_email';
const GOOGLE_USER = '@agroreceita_google_user';
const GOOGLE_USER_PROFILE = '@agroreceita_google_user_profile';

const ProfileMenu = ({ userData, planId, diasRestantes, isMobile }) => {
  const [profileName, setProfileName] = useState('');
  const [isAccordionOpen, setAccordionOpen] = useState(false);
  const [showProfile, setShowProfile] = useState(true);
  const [userId, setUserId] = useState(null);
  const [width, setWidth] = useState(window.innerWidth);

  let userGoogleData;
  try {
    const googleUserData = localStorage.getItem(GOOGLE_USER);
    userGoogleData = googleUserData && googleUserData.startsWith('{') ? JSON.parse(googleUserData) : { profile: { picture: null }, name: googleUserData };
  } catch (error) {
    console.error('Erro ao fazer parse do userGoogleData:', error);
    userGoogleData = { profile: { picture: null } };
  }
  const userShortName = userData?.name?.split(' ')[0];
  const userProfilePicture = userGoogleData?.profile?.picture;

  const accordionRef = useRef(null);

  const exit = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: 'logout', source: 'web', from: 'user-menu' })
      );
    }

    if (planId === 1 && diasRestantes === 7) {
      // Caso específico, pode manter vazio ou inserir lógica
    } else {
      setTimeout(() => {
        localStorage.removeItem(GOOGLE_EMAIL);
        localStorage.removeItem(GOOGLE_USER);
        localStorage.removeItem(GOOGLE_USER_PROFILE);
        window.location = '/login';
      }, 100);
    }
  };

  const toggleAccordion = () => setAccordionOpen(prev => !prev);

  const photoOrName = () =>
    userProfilePicture ? (
      <img src={userProfilePicture} alt="Imagem de perfil" />
    ) : (
      <S.NameProfile>
        <BodyMSpan>{profileName}</BodyMSpan>
      </S.NameProfile>
    );

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('@userinfo'));
    if (user && user.name) {

      const nameParts = user.name.split(' ').filter(name => name.length > 0);
      let initials;

      if (nameParts.length >= 2) {
        initials = nameParts[0][0] + nameParts[1][0];
      } else {
        initials = nameParts[0].substring(0, 2);
      }

      initials = initials.toUpperCase();

      setProfileName(initials);
      setUserId(user.id);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
      if (window.innerWidth <= 767 || window.innerWidth >= 767) setShowProfile(true);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = e => {
      if (accordionRef.current && !accordionRef.current.contains(e.target)) {
        setAccordionOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (!showProfile) return null;

  return (
    <S.Profile onClick={toggleAccordion} ref={accordionRef}>
      {photoOrName()}
      <TaglinePSpan>{userShortName}</TaglinePSpan>
      <S.ButtonProfile>
        <img
          src={ArrowDown}
          alt="Seta"
          className={`animate__animated ${isAccordionOpen ? 'animate__rotateInDownUp' : 'animate__rotateInDown'}`}
          style={{
            transform: isAccordionOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s ease',
          }}
        />
      </S.ButtonProfile>

      {isAccordionOpen && (
        <S.Accordion 
          isTotvs={isTotvs()}
          isTotvsMaster={userData?.agro_permission_id === 4 ? true : false}
          >
          {!isTotvs() ? (
            <>
              <a href={`/usuarios/${userId}`}>MEUS DADOS</a>
              {isMobile && planId && planId !== 5 && (
                <a href="/planos">ATUALIZAÇÃO DE PLANO</a>
              )}
              <a href="/faturamento">DADOS DE FATURAMENTO</a>
              <a href="/filiais">MINHA EMPRESA</a>
              <a href="/usuarios">USUÁRIOS</a>
              <a href="/integracao">INTEGRAÇÃO</a>
          </>
          ) : (
            <>
            {/* MASTER */}
            {userData?.agro_permission_id === 4 ? (
              <>
                <a href="/filiais">MINHA EMPRESA</a>
                <a href="/usuarios">USUÁRIOS</a>
                <a href="/integracao-webhook">INTEGRAÇÃO WEBHOOK</a>
              </>
            ) : (
              <>
                <a href={`/usuarios/${userId}`}>MEUS DADOS</a>
                <a href="/faturamento">DADOS DE FATURAMENTO</a>
                <a href="/filiais">MINHA EMPRESA</a>
                <a href="/usuarios">USUÁRIOS</a>
              </>
            )}
            </>
          )}
          
          <S.AccordionItem onClick={exit}>SAIR</S.AccordionItem>
        </S.Accordion>
      )}
    </S.Profile>
  );
};

export default ProfileMenu;
